export function splitHeroStatValue(value: string) {
  const normalized = value.trim().replace(/,/g, '');
  const match = normalized.match(/^(\d+(?:\.\d+)?)(.*)$/);

  if (!match) {
    return { number: 0, suffix: value, decimals: 0, isNumeric: false, useComma: false };
  }

  const [, numericValue, suffix = ''] = match;
  const number = Number(numericValue);

  return {
    number,
    suffix,
    decimals: numericValue.includes('.') ? numericValue.split('.')[1]?.length || 0 : 0,
    isNumeric: true,
    useComma: number >= 1000,
  };
}
